import { useLayoutEffect } from "react";
import useSearchParams from "@hooks/use-search-params";

const usePageChange = (props) => {
    /* Destructuring the props object. */
    const { setQueryParams } = props;
    const { createSearchParams, getSearchParams } = useSearchParams();

    /* A react router hook that allows you to get the search params from the URL. */

    const page = Math.round(getSearchParams("page")) || 1;
    const limit = Math.round(getSearchParams("limit")) || 50;

    const handlePaginationOnLoad = () => {
        createSearchParams("page", page <= 0 ? 1 : page);
        if (limit > 1000 && location.pathname.includes("logs")) {
            createSearchParams("limit", 1000);
        } 
        if (limit > 50 && !location.pathname.includes("logs")) {
            createSearchParams("limit", 50);
        } else if (limit <= 5) {
            createSearchParams("limit", 5);
        } else {
            createSearchParams("limit", limit);
        }
    };

    /**
   * It changes the page number.
   * @param page - The current page number
   */
    const handlePageChange = (page) => {
        createSearchParams("page", page);
        setQueryParams((params) => ({
            ...params,
            page
        }));
    };

    /**
   * It sets the number of rows per page.
   * @param newPerPage - The new number of rows per page
   * @param page - The current page number
   */
    const handlePerRowsChange = (newPerPage, page) => {
        createSearchParams("limit", newPerPage);
        createSearchParams("page", page);
        setQueryParams((params) => ({
            ...params,
            page,
            limit: newPerPage
        }));
    };
    /**
   * It changes the limit .
   * @param limit - The limit
   */
    const handleLimit = (limit) => {
        createSearchParams("limit", limit);
        setQueryParams((params) => ({
            ...params,
            page: 1,
            limit
        }));
    };

    useLayoutEffect(() => {
        handlePaginationOnLoad();
    }, []);

    return {
        handlePageChange,
        handlePerRowsChange,
        handleLimit
    };
};

export default usePageChange;
